import React, { useState } from "react";
import { Routes, Route, Navigate, NavLink, useLocation } from "react-router-dom";
import Transaction from "../Transaction/Transaction";
import Settlement from "../Settlement/Settlement";
import Refund from "../Refund/Refund";
import { IoIosArrowDown } from "react-icons/io";
import VendorTransaction from "./VendorTransaction";
import VendorSettlement from "./VendorSettlement";
import Disputes from "./Dispute";

const tabClass = ({ isActive }: { isActive: boolean }) =>
  isActive
    ? "bg-[#6687FF33] bg-opacity-20 py-1.5 font-semibold rounded-lg text-[14px] text-left pl-10 text-[#1B163B]"
    : "py-1.5 font-semibold rounded-lg text-[14px] text-left pl-10 text-[#717171]";

const subTabClass = ({ isActive }: { isActive: boolean }) =>
  isActive
    ? "bg-[#6687FF33] py-1.5 font-semibold rounded-lg text-[14px] text-left pl-14 text-[#1B163B]"
    : "py-1.5 font-semibold rounded-lg text-[14px] text-left pl-14 text-[#717171]";

function Payments({ menu }: { menu: boolean }) {
  const location = useLocation();
  const [vendorTab, setVendorTab] = useState(
    location.pathname.includes("/vendor/"),
  );
  const isESplitActive = location.pathname.includes("/vendor/");

  return (
    <div className="flex">
      <div
        className={
          "  transition-transform duration-200 fixed overflow-hidden   pt-10 " +
          (menu ? "translate-x-0 w-56" : " -translate-x-[100%] w-0 ")
        }
      >
        <div className=" flex flex-col  min-h-screen shrink-0">
          <NavLink to="/payments/transactions" className={tabClass} end={false}>
            Transactions
          </NavLink>
          <NavLink to="/payments/settlements" className={tabClass}>
            Settlements
          </NavLink>
          <NavLink to="/payments/refunds" className={tabClass}>
            Refund
          </NavLink>
          <NavLink to="/payments/disputes" className={tabClass}>
            Disputes
          </NavLink>
          <div
            className={
              "cursor-pointer relative flex  items-center pr-4 " +
              (isESplitActive
                ? "bg-[#6687FF33] font-semibold rounded-lg text-[14px] text-left  text-[#1B163B]"
                : "  font-semibold rounded-lg text-[14px] text-left  text-[#717171]")
            }
          >
            <NavLink
              to="/payments/vendor/transactions"
              className="pl-[2.5rem] w-full py-1.5 block"
              onClick={() => setVendorTab(true)}
            >
              E-Split
            </NavLink>
            <span
              onClick={() => {
                setVendorTab((prev) => !prev);
              }}
            >
              <IoIosArrowDown
                className={
                  " text-lg duration-200 transition-transform" +
                  (vendorTab === true ? " rotate-0 " : " -rotate-180")
                }
              />
            </span>
            {vendorTab === true && (
              <div className="left-0 absolute z-40 flex flex-col w-full -bottom-[70px]">
                <NavLink
                  to="/payments/vendor/transactions"
                  className={subTabClass}
                >
                  Vendor Transaction
                </NavLink>
                <NavLink
                  to="/payments/vendor/settlements"
                  className={subTabClass}
                >
                  Vendor Settlement
                </NavLink>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={"tab-content w-full py-4 " + (menu ? " pl-64" : " pl-2")}>
        <Routes>
          <Route index element={<Navigate to="transaction" replace />} />
          <Route path="transactions" element={<Transaction />} />
          <Route path="settlements" element={<Settlement />} />
          <Route path="refunds" element={<Refund />} />
          <Route path="disputes" element={<Disputes />} />
          <Route path="vendor/transactions" element={<VendorTransaction />} />
          <Route path="vendor/settlements" element={<VendorSettlement />} />
          <Route path="*" element={<Navigate to="transaction" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default Payments;
